export default __webpack_public_path__ + "media/images/shapes/double-pyramid-d6e4a8c8ab694beb5a15b4f7453ae570.svg";